import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $, { data } from 'jquery'
import { fetchSearchOptionsRequest } from '../actions'
import { fetchPropertiesByFilterRequest, setSelectedOptionsRequest } from '../../Landing/actions'
import DropDownData from '../dropDownData'
import { Slider } from '@material-ui/core'
import { useHistory, useLocation } from "react-router-dom"
import request from '../../../service/request'
import { getQueryString } from '../../../helper'
import { Tab, Tabs } from 'react-bootstrap'


const SearchFilters = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const [filterData, setFilterData] = useState({});
    const filterOptions = useSelector(store => store.commonPageData.searchOptions);
    const propertyTypeOption = useSelector(store => store.landingPageData.selectedOptions.property_type);
    const SpecificPropertyOption = useSelector(store => store.landingPageData.selectedOptions.specific_property);
    const propertyConfigOption = useSelector(store => store.landingPageData.selectedOptions.property_configuration);
    const propertyForOption = useSelector(store => store.landingPageData.selectedOptions.property_for);
    const countryOption = useSelector(store => store.landingPageData.selectedOptions.country);
    const stateOption = useSelector(store => store.landingPageData.selectedOptions.state);
    const cityOption = useSelector(store => store.landingPageData.selectedOptions.city);
    const hotPropertyOption = useSelector(store => store.landingPageData.selectedOptions.hot_property);
    const areaOption = useSelector(store => store.landingPageData.selectedOptions.area);
    const areaSizeOption = useSelector(store => store.landingPageData.selectedOptions.area_size);
    const budgetOption = useSelector(store => store.landingPageData.selectedOptions.budget);
    const measurementOption = useSelector(store => store.landingPageData.selectedOptions.measurement);
    const measurementLable = useSelector(store => store.commonPageData.measurement_lable);

    const allSelectedOption = useSelector(store => store.landingPageData.selectedOptions);
    const shouldClearDropdown = location.pathname !== '/hot-property';

    const [areaSize, setAreaSize] = useState([100, 5000]);
    const [budget, setBudget] = useState([1000, 1000000000]);
    const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [area, setArea] = useState([]);
    const [specificProperty, setSpecificProperty] = useState([]);
    const [propertyConfiguration, setPropertyConfiguration] = useState([])
    const [clearKey, setClearKey] = useState(0);
    const [clearHotProperty, setClearHotProperty] = useState(true);
    const [clearDropdown, setClearDropdown] = useState(false);

    const [searchFileds, setSearchFileds] = useState([]);

    const loadData = () => {
        request({
            method: 'post',
            url: 'property-search-fields',
            headers: { "Content-Type": "application/json", "Accept": "application/json" }
        }).then((response) => {
            if (response.data.code == 0) {
                setSearchFileds(response.data.data);
            }
        }).catch((error) => {
            
        });
    }

    useEffect(() => {
        loadData();
    }, []);

    const handleAreaChange = (e, newFirstValue) => {
        e.preventDefault();
        setAreaSize(newFirstValue);
        const optVal = newFirstValue;
        const foptVal = optVal.join(",");
        dispatch(setSelectedOptionsRequest({ 'area_size': foptVal }));
    };
    const handleBudgetChange = (e, newFirstValue) => {
        e.preventDefault();
        setBudget(newFirstValue);
        const optVal = newFirstValue;
        const foptVal = optVal.join(",");
        dispatch(setSelectedOptionsRequest({ 'budget': foptVal }));
    };

    useEffect(() => {
        loadSearchData();
    }, []);

    useEffect(() => {
        if (typeof filterOptions === 'object' && filterOptions.data && (Object.keys(filterOptions.data)).length > 0) {
            setFilterData(filterOptions.data);
        }
    }, [filterOptions]);

    useEffect(() => {
        /** Load city data reamining.. */
        loadCity(12);
    }, [])

    useEffect(() => {
        loadAreas(101, 12, cityOption);
    }, [cityOption])

    function loadSearchData() {
        dispatch(fetchSearchOptionsRequest(JSON.stringify([data])));
    }
    function loadCity(stateid) {
        request({
            method: 'post',
            url: '/get-city-by-State',
            data: { 'state_id': stateid }
        }).then((response) => {
            setCity(response.data.data.cities);
        });
    }
    function loadAreas(country_id, state_id, city_id) {
        request({
            method: 'post',
            url: '/get-areas',
            data: { 'country_id': country_id, 'state_id': state_id, 'city_id': city_id }
        }).then((response) => {
            setArea(response.data.data.areas);
        });
    }
    useEffect(() => {
        setState(filterData?.locations);
    }, [filterData]);

    useEffect(() => {
        if (propertyTypeOption) {
            request({
                method: 'post',
                url: '/get-specific-properties',
                data: { 'property_type': propertyTypeOption }
            }).then((response) => {
                setSpecificProperty(response.data.data.specific_property);
            });

            request({
                method: 'post',
                url: '/get-property-config',
                data: { 'property_type': propertyTypeOption }
            }).then((response) => {
                setPropertyConfiguration(response.data.data.property_config);
            })
        } else {
            setSpecificProperty([]);
            setPropertyConfiguration([]);
        }
    }, [propertyTypeOption])

    useEffect(() => {
        let kinjal = (areaSizeOption && areaSizeOption.length > 0) ? (areaSizeOption.split(',')).map((i) => { return parseInt(i) }) : [100, 5000];
        if (kinjal && kinjal.length > 0) {
            setAreaSize(kinjal);
        }
    }, [areaSizeOption]);

    useEffect(() => {
        let propertyForTag = document.querySelector('.nav-link.active');
        let propertyFor = propertyForTag ? propertyForTag.innerText.toLowerCase() : 'buy';
        let budgetArr = (budgetOption && budgetOption.length > 0) ? (budgetOption.split(',')).map((i) => { return parseInt(i) }) : (propertyFor === 'rent') ? [1000, 100000] : [1000000, 10000000];
        if (budgetArr && budgetArr.length > 0) {
            setBudget(budgetArr);
        }
    }, [budgetOption]);

    const handleClick = (event) => {
        if (event.type === 'click') {
            let QueryString = "";
            if (typeof allSelectedOption === 'object' && Object.keys(allSelectedOption).length > 0) {
                let propertyForTag = document.querySelector('.nav-link.active');
                let propertyFor = '';
                if(propertyForTag){
                    propertyFor = propertyForTag.innerText.toLowerCase();
                    if(propertyFor === 'rent'){
                        propertyFor = 1;
                    }else if(propertyFor === 'buy'){
                        propertyFor = 2;
                    }
                    allSelectedOption.property_for = propertyFor;
                }

                if(allSelectedOption.area_size == null || allSelectedOption.area_size == ""){
                    allSelectedOption.area_size = "100,5000";
                }
                if(allSelectedOption.budget == null || allSelectedOption.budget == ""){
                    allSelectedOption.budget = allSelectedOption?.property_for == 1 ? "1000,100000" : "1000000,10000000";
                }
                // console.log('object', allSelectedOption);
                QueryString = getQueryString(allSelectedOption);
                // dispatch the properties list by selected filter options..
                dispatch(fetchPropertiesByFilterRequest(JSON.stringify(allSelectedOption)))
            }
            dispatch(setSelectedOptionsRequest(allSelectedOption));
            history.push({
                pathname: '/all/property',
                search: `?${QueryString}`
            })
        }
    }

    const handleClearDropdown = (k='') => {
        if(k){
            setKey(k);
        }
        setClearHotProperty(true);
        setClearKey((prevKey) => prevKey + 1);
        setAreaSize([100, 5000]);
        
        let propertyForTag = document.querySelector('.nav-link.active');
        let propertyFor = propertyForTag ? propertyForTag.innerText.toLowerCase() : 'buy';
        let budgetArr = propertyFor === 'buy' ? [1000, 100000] : [1000000, 10000000];
        setBudget(budgetArr);

        dispatch(setSelectedOptionsRequest({
            hot_property:'',
            property_type: '',
            property_for: propertyFor === 'buy' ? 1 : 2,
            specific_property: '',
            measurement:'',
            area_size:"",
            budget:"",
            area:'',
            country:101,
            state:12,
            city:'',
            page:1,
            sort_by:'latest',
            property_configuration:''
        }));
        dispatch(fetchPropertiesByFilterRequest(JSON.stringify({
            hot_property:'',
            property_type: '',
            property_for: propertyFor === 'buy' ? 1 : 2,
            specific_property: '',
            measurement:'',
            area_size: "",
            budget: "",
            area:'',
            country:101,
            state:12,
            city:'',
            page:1,
            sort_by:'latest',
            property_configuration:''
        })))
    };

    const [key, setKey] = useState('buy-property');
    useEffect(() => {
        if(location.pathname == '/'){
            setKey('buy-property');
        }else{
            if (allSelectedOption && Object.keys(allSelectedOption).length > 0) {
                setKey(allSelectedOption.property_for == 1 ? 'rent-property' : 'buy-property');
            }else{
                setKey('buy-property');
            }
        }
    }, []);

    return (
        <>
            {/* <!-- Search Form --> */}
            <div className="col-xl-12 px-0 parallax-searchs">
                <div className="banner-search-wrap" id="property-search-box">
                    <Tabs id="property-search-tabs" className="d-flex justify-content-center" activeKey={key} onSelect={(k) => handleClearDropdown(k)}>
                        <Tab eventKey="buy-property" title="Buy">
                            <div className="rld-main-search h-auto">
                                <div className={`row justify-content-center ${searchFileds && searchFileds.length > 3 ? ' justify-content-lg-start' : ''} search-margin align-items-center`}>
                                    {
                                        filterData && searchFileds && Object.keys(filterData).length > 0 && searchFileds.length > 0 &&
                                            <>
                                                {
                                                    searchFileds.includes("Property Type") && 
                                                    <DropDownData className='col-lg-3 col-md-4 col-sm-6 col-12' options={filterData && filterData?.property_types} storeKey={'property_type'} choosedOption={'Property Type'} defaultOption={(propertyTypeOption) ? propertyTypeOption : ''} clearDropdown={clearDropdown} clearKey={clearKey} />
                                                }
                                                {
                                                    searchFileds.includes("Specific Property") && 
                                                    <DropDownData className='col-lg-3 col-md-4 col-sm-6 col-12' options={specificProperty} storeKey='specific_property' choosedOption={'Specific Property'} defaultOption={(propertyTypeOption && SpecificPropertyOption) ? SpecificPropertyOption : ''} clearDropdown={clearDropdown} clearKey={clearKey} />
                                                }
                                                {
                                                    searchFileds.includes("Property Configuration") && 
                                                    <DropDownData className='col-lg-3 col-md-4 col-sm-6 col-12' options={propertyConfiguration} storeKey='property_configuration' choosedOption={'Property Configuration'} defaultOption={(propertyTypeOption && propertyConfigOption) ? propertyConfigOption : ''} clearDropdown={clearDropdown} clearKey={clearKey} />
                                                }
                                                {
                                                    searchFileds.includes("City & Area (Locality)") && 
                                                    <DropDownData className='col-lg-3 col-md-4 col-sm-6 col-12' options={city} storeKey='city' choosedOption={'City'} defaultOption={cityOption ? cityOption : ''} clearDropdown={clearDropdown} clearKey={clearKey} />
                                                }
                                                {
                                                    searchFileds.includes("City & Area (Locality)") && 
                                                    <DropDownData className='col-lg-3 col-md-4 col-sm-6 col-12' options={area} storeKey='area' choosedOption={'Area (Locality)'} defaultOption={areaOption ? areaOption : ''} clearDropdown={clearDropdown} clearKey={clearKey} />
                                                }
                                                {
                                                    searchFileds.includes("Area (Size)") &&
                                                    <div className='rld-single-select ml-22 col-lg-3 col-md-4 col-sm-6 col-12'>
                                                        <label className='align-self-start d-flex text-muted font-weight-bold'>Area (Size)</label>
                                                        <Slider
                                                            value={areaSize}
                                                            className="area-range range-slider "
                                                            onChange={handleAreaChange}
                                                            color="secondary"
                                                            step={100}
                                                            min={100}
                                                            max={50000}
                                                        />
                                                        <div className='text-left float-left'>{areaSize[0]} {measurementLable ? measurementLable : ""}</div>
                                                        <div className='text-right float-right'>{areaSize[1]} {measurementLable ? measurementLable : ""}</div>
                                                    </div>
                                                }
                                                {
                                                    searchFileds.includes("Budget") &&
                                                    <div className='rld-single-select ml-22 col-lg-3 col-md-4 col-sm-6 col-12'>
                                                        <label className='align-self-start d-flex text-muted font-weight-bold'>Budget</label>
                                                        <Slider
                                                            value={budget}
                                                            className="budget-range range-slider "
                                                            onChange={handleBudgetChange}
                                                            color="secondary"
                                                            step={10000}
                                                            min={1000000}
                                                            max={1000000000}
                                                        />
                                                        <div className='text-left float-left'>{budget[0]} {measurementLable ? measurementLable : ""}</div>
                                                        <div className='text-right float-right'>{budget[1]} {measurementLable ? measurementLable : ""}</div>
                                                    </div>
                                                }
                                            </>
                                    }
                                    <div className="rld-single-select ml-22  col-lg-12 col-md-12 mt-3 d-flex justify-content-center">
                                        <button className="btn btn-yellow customButton" onClick={handleClick} >Search Now</button>
                                        <button className="btn btn-yellow customClearButton ml-5" onClick={handleClearDropdown}>Clear</button>
                                    </div>
                                </div>
                            </div>
                        </Tab>
                        { process.env.REACT_APP_ENDPOINT != "seokservices" && <Tab eventKey="rent-property" title="Rent">
                            <div className="rld-main-search h-auto">
                                <div className={`row justify-content-center ${searchFileds && searchFileds.length > 3 ? ' justify-content-lg-start' : ''} search-margin align-items-center`}>
                                    {
                                        filterData && searchFileds && Object.keys(filterData).length > 0 && searchFileds.length > 0 &&
                                            <>
                                                {
                                                    searchFileds.includes("Property Type") && 
                                                    <DropDownData className='col-lg-3 col-md-4 col-sm-6 col-12' options={filterData && filterData?.property_types} storeKey={'property_type'} choosedOption={'Property Type'} defaultOption={(propertyTypeOption) ? propertyTypeOption : ''} clearDropdown={clearDropdown} clearKey={clearKey} />
                                                }
                                                {
                                                    searchFileds.includes("Specific Property") && 
                                                    <DropDownData className='col-lg-3 col-md-4 col-sm-6 col-12' options={specificProperty} storeKey='specific_property' choosedOption={'Specific Property'} defaultOption={(propertyTypeOption && SpecificPropertyOption) ? SpecificPropertyOption : ''} clearDropdown={clearDropdown} clearKey={clearKey} />
                                                }
                                                {
                                                    searchFileds.includes("Property Configuration") && 
                                                    <DropDownData className='col-lg-3 col-md-4 col-sm-6 col-12' options={propertyConfiguration} storeKey='property_configuration' choosedOption={'Property Configuration'} defaultOption={(propertyTypeOption && propertyConfigOption) ? propertyConfigOption : ''} clearDropdown={clearDropdown} clearKey={clearKey} />
                                                }
                                                {
                                                    searchFileds.includes("City & Area (Locality)") && 
                                                    <DropDownData className='col-lg-3 col-md-4 col-sm-6 col-12' options={city} storeKey='city' choosedOption={'City'} defaultOption={cityOption ? cityOption : ''} clearDropdown={clearDropdown} clearKey={clearKey} />
                                                }
                                                {
                                                    searchFileds.includes("City & Area (Locality)") && 
                                                    <DropDownData className='col-lg-3 col-md-4 col-sm-6 col-12' options={area} storeKey='area' choosedOption={'Area (Locality)'} defaultOption={areaOption ? areaOption : ''} clearDropdown={clearDropdown} clearKey={clearKey} />
                                                }
                                                {
                                                    searchFileds.includes("Area (Size)") &&
                                                    <div className='rld-single-select ml-22 col-lg-3 col-md-4 col-sm-6 col-12'>
                                                        <label className='align-self-start d-flex text-muted font-weight-bold'>Area (Size)</label>
                                                        <Slider
                                                            value={areaSize}
                                                            className="area-range range-slider "
                                                            onChange={handleAreaChange}
                                                            color="secondary"
                                                            step={100}
                                                            min={100}
                                                            max={50000}
                                                        />
                                                        <div className='text-left float-left'>{areaSize[0]} {measurementLable ? measurementLable : ""}</div>
                                                        <div className='text-right float-right'>{areaSize[1]} {measurementLable ? measurementLable : ""}</div>
                                                    </div>
                                                }
                                                {
                                                    searchFileds.includes("Budget") &&
                                                    <div className='rld-single-select ml-22 col-lg-3 col-md-4 col-sm-6 col-12'>
                                                        <label className='align-self-start d-flex text-muted font-weight-bold'>Budget</label>
                                                        <Slider
                                                            value={budget}
                                                            className="budget-range range-slider "
                                                            onChange={handleBudgetChange}
                                                            color="secondary"
                                                            step={1000}
                                                            min={1000}
                                                            max={1000000}
                                                        />
                                                        <div className='text-left float-left'>{budget[0]} {measurementLable ? measurementLable : ""}</div>
                                                        <div className='text-right float-right'>{budget[1]} {measurementLable ? measurementLable : ""}</div>
                                                    </div>
                                                }
                                            </>
                                    }
                                    <div className="rld-single-select ml-22  col-lg-12 col-md-12 mt-3 d-flex justify-content-center">
                                        <button className="btn btn-yellow customButton" onClick={handleClick} >Search Now</button>
                                        <button className="btn btn-yellow customClearButton ml-5" onClick={handleClearDropdown}>Clear</button>
                                    </div>
                                </div>
                            </div>
                        </Tab> }
                    </Tabs>
                </div>
            </div>
            {/* <!--/ End Search Form --> */}
        </>
    )
}

export default SearchFilters
